import { useQuery } from "@tanstack/react-query";
import { tournamentLeaderboardQueryOptions } from "@/api/tournamentAnalysis";
import { useTournamentContext } from "../page";
import { TournamentRankingTable } from "@/components/general/TournamentAnalysis/TournamentRankingTable";
import type { StatCategory } from "@/components/general/TournamentAnalysis/TournamentRankingTable";

export const TournamentRankingPage = () => {
    const { selectedTournamentId, tournaments, statCategory } = useTournamentContext();
    const isTournamentsLoading = tournaments === undefined;

    const { data: tournamentLeaderboardData, isLoading: tournamentLeaderboardLoading } = useQuery({
        ...tournamentLeaderboardQueryOptions(selectedTournamentId || 0),
        enabled: !!selectedTournamentId && selectedTournamentId > 0,
    });

    const teamCategory: StatCategory =
        statCategory === "overview" ||
        statCategory === "shooting" ||
        statCategory === "passing" ||
        statCategory === "puck" ||
        statCategory === "faceoffs" ||
        statCategory === "advanced" ||
        statCategory === "special"
            ? statCategory
            : "overview";

    return (
        <div
            id="onboarding-tournament-ranking-table"
            className="flex-1 min-h-0 h-full flex flex-col rounded-md overflow-hidden border-table-border-color"
        >
            <TournamentRankingTable
                data={tournamentLeaderboardData?.teams || []}
                isLoading={tournamentLeaderboardLoading || isTournamentsLoading}
                selectedCategory={teamCategory}
            />
        </div>
    );
};
